import { z } from 'zod';
/** Standard error envelope returned by every non-2xx API response. */
export const ApiErrorSchema = z.object({
    error: z.object({
        code: z.string().min(1),
        message: z.string().min(1),
        details: z.record(z.unknown()).optional(),
    }),
});
//# sourceMappingURL=error.js.map